import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { decodeToken } from 'react-jwt'
import { ITokenParseUser, ITokensResponse } from 'models/auth'
import { ISellerEmployee } from 'models/sellerEmployees'
import { TOKEN } from 'shared/constants/app'
import { AppState } from './types'

const initialState: AppState = {
  token: null,
  userId: null,
  sellerId: null,
  sellerStatus: null,
  role: null,
  employeeId: null,
  employee: null,
  isStoreHidden: false,
  isHiddenBySeller: false
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<ITokensResponse>) {
      const user = decodeToken(action.payload.access_token) as ITokenParseUser
      state.userId = user?._id ?? null
      state.sellerId = user?.seller_id ?? null
      state.sellerStatus = user?.seller_status ?? null
      state.role = user.role
      const employeeId = user?.employee_id ?? null
      if (employeeId !== state.employeeId) state.employee = null
      state.employeeId = employeeId
      state.token = action.payload.access_token
      localStorage.setItem(TOKEN, action.payload.access_token)
    },
    setEmployee(state, action: PayloadAction<ISellerEmployee | null>) {
      state.employee = action.payload
    },
    setStoreHidden(
      state,
      action: PayloadAction<Pick<AppState, 'isStoreHidden' | 'isHiddenBySeller'>>
    ) {
      state.isStoreHidden = action.payload.isStoreHidden
      state.isHiddenBySeller = action.payload.isHiddenBySeller
    },
    logout(state) {
      state.token = null
      state.userId = null
      state.sellerId = null
      state.sellerStatus = null
      state.role = null
      state.employeeId = null
      state.employee = null
      state.isStoreHidden = false
      state.isHiddenBySeller = false
      localStorage.removeItem(TOKEN)
    }
  }
})

export default appSlice.reducer
export const actions = appSlice.actions
